import React, { Component } from "react";
// import { Alert } from "reactstrap";
import './FileTraceAlertSection.css';
import FileSearchIcon from "../../../../assets/filesearchicon.png";
import { Alert } from 'antd';
import { ExclamationCircleOutlined, ExclamationCircleTwoTone } from '@ant-design/icons';
import 'antd/dist/antd.css';

class FileTraceAlertSection extends Component {
    render() {
        return (
                <Alert
                message={<span><ExclamationCircleOutlined style={{color:"#fa8104", verticalAlign: "0.125em",margin: "0 0.5rem"}}/> Your documents are being processed and will appear when ready upon refresh</span>}
                // showIcons={false}
                // icon={<ExclamationCircleOutlined />}
                type="warning"
                className="filetraceTopBanner"
                />
                // <Alert
                // message={<span className="alertIcon"><img src={FileSearchIcon} alt='fileSearch' />We are smart scanning your files and will post real-time status updates below.</span>}
                // banner
                // closable
                // showIcon={false}
                // type="warning"
                // />
        );
    }    
}

export default FileTraceAlertSection;